import { Components } from "formiojs";

import SurveyEditData from "./editForm/Survey.edit.data";

export default function (...extend) {
  return Components.baseEditForm([
    {
      key: "data",
      components: SurveyEditData
    }
  ], ...extend);
}
